var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActivePolicy = function SvgActivePolicy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00C48C",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.126 16.171c0 3.824-2.128 6.642-8.346 10.901-6.218-4.259-8.346-7.077-8.346-10.9V6.475c3.092-.33 5.568-1.39 8.346-3.555 2.778 2.164 5.254 3.224 8.346 3.555v9.695zm1.826-11.999c-3.658-.083-6.173-.97-9.715-4.008A.703.703 0 0 0 10.78 0a.702.702 0 0 0-.457.164C6.78 3.202 4.266 4.089.609 4.172a.617.617 0 0 0-.609.61v11.39c0 5.536 3.733 9.118 10.274 13.48.14.094.323.14.506.14a.922.922 0 0 0 .506-.14c6.54-4.362 10.274-7.944 10.274-13.48V4.781a.617.617 0 0 0-.608-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.478 14.1a.704.704 0 0 0-.902.006l-.794.711a.516.516 0 0 0 .008.794l3.264 2.816a.708.708 0 0 0 .915.006l5.7-5.012a.516.516 0 0 0 0-.793l-.802-.704a.704.704 0 0 0-.902 0l-4.462 3.923-2.025-1.748z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActivePolicy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/active-policy.4855deed.svg";
export { ForwardRef as ReactComponent };